import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ExceptionMessage21t2b5aa8xtox as ExceptionMessage } from '../../../../kiteui-library/com/lightningkite/kiteui/exceptions/handling.mjs';
import { NullPointerException3mu0rhxjjitqq as NullPointerException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NotFoundClass;
function NotFound() {
  if (NotFoundClass === VOID) {
    class $ extends RequestException() {
      static pfx(modelType, message) {
        message = message === VOID ? null : message;
        var $this = this.wfx(modelType, message == null ? '' + modelType.ff() + ' was not found' : message);
        captureStack($this, $this.ofx_1);
        return $this;
      }
    }
    initMetadataForClass($, 'NotFound');
    NotFoundClass = $;
  }
  return NotFoundClass;
}
var CreationErrorClass;
function CreationError() {
  if (CreationErrorClass === VOID) {
    class $ extends RequestException() {
      static efy(modelType) {
        var $this = this.wfx(modelType, 'Error in creating ' + modelType.ff());
        captureStack($this, $this.dfy_1);
        return $this;
      }
    }
    initMetadataForClass($, 'CreationError');
    CreationErrorClass = $;
  }
  return CreationErrorClass;
}
var HandlerClass;
function Handler() {
  if (HandlerClass === VOID) {
    class $ {
      constructor() {
        this.ffy_1 = 2.0;
      }
      g90() {
        return this.ffy_1;
      }
      bcw(view, exception) {
        if (!(exception instanceof RequestException()))
          return null;
        return new (ExceptionMessage())('Request Exception', exception.j());
      }
    }
    initMetadataForObject($, 'Handler');
    HandlerClass = $;
  }
  return HandlerClass;
}
var Handler_instance;
function Handler_getInstance() {
  return Handler_instance;
}
var RequestExceptionClass;
function RequestException() {
  if (RequestExceptionClass === VOID) {
    class $ extends NullPointerException() {
      static wfx(modelType, message) {
        var $this = this.s4();
        captureStack($this, $this.vfx_1);
        $this.tfx_1 = modelType;
        $this.ufx_1 = message;
        delete $this.message;
        return $this;
      }
      j() {
        return this.ufx_1;
      }
      get message() {
        return this.j();
      }
    }
    initMetadataForClass($, 'RequestException');
    RequestExceptionClass = $;
  }
  return RequestExceptionClass;
}
//region block: init
Handler_instance = new (Handler())();
//endregion
//region block: exports
export {
  CreationError as CreationError2yp65thg4sfbo,
  NotFound as NotFoundikk4a5uq9edp,
  Handler_instance as Handler_instance26jr8uh1iqbs3,
};
//endregion

//# sourceMappingURL=errors.mjs.map
